import * as types from '../mutation-types'
import Cookie from "js-cookie";

const state = {
  main: {}
}

const mutations = {
  [types.FETCH_PERFIL] (state, perfil) {
    state.main = perfil
  },
  [types.LOGOUT_PERFIL] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = {};
    //  Cookie.remove('token');
    localStorage.removeItem('token');
  },
}

export default {
  state,
  mutations
}
